import { getHubEventSchedule } from '@/app/(publishing)/event/([hub])/data';

const pad = (n: number) => String(n).padStart(2, '0');

export type PopupSchedule = {
  /** 참고용 시작일 (노출 판정에는 사용하지 않음) */
  startDate?: string;
  /** 노출 종료 (KST, YYYY-MM-DD 또는 YYYY-MM-DD HH:mm). 날짜만 쓰면 그날 23:59:59까지 */
  endDate?: string;
};

export type SchedulablePopup = PopupSchedule & {
  /** HUB_EVENTS href와 일치하면 period 자동 연동. startDate/endDate가 있으면 우선 */
  href?: string;
};

/** 하드코딩 startDate/endDate → href로 HUB_EVENTS period 조회 */
export function resolvePopupSchedule(entry: SchedulablePopup): PopupSchedule {
  if (entry.startDate || entry.endDate) {
    return { startDate: entry.startDate, endDate: entry.endDate };
  }

  if (!entry.href) return {};

  return getHubEventSchedule(entry.href) ?? {};
}

/**
 * 'YYYY-MM-DD' 또는 'YYYY-MM-DD HH:mm' → 타임스탬프. 월·일·시·분 자릿수 무관, 분 생략 가능
 * 게시 기간은 접속자 타임존과 무관하게 KST(+09:00)로 판정한다
 * endOfDay: 시간이 생략된 경우 그날 끝(23:59:59.999)으로 해석
 */
function toKstTime(value: string, endOfDay = false): number {
  const [y, mo, d, h, mi] = value.trim().split(/[-\s:]+/).map(Number);
  const date = `${y}-${pad(mo)}-${pad(d)}`;
  if (h === undefined && endOfDay) return new Date(`${date}T23:59:59.999+09:00`).getTime();

  return new Date(`${date}T${pad(h ?? 0)}:${pad(mi ?? 0)}:00+09:00`).getTime();
}

/** 시작일은 무시하고, 종료일만 초과했을 때 미노출 */
export function isWithinSchedule(schedule: PopupSchedule): boolean {
  const now = Date.now();
  if (schedule.endDate && now > toKstTime(schedule.endDate, true)) return false;
  return true;
}
